import { FC } from 'react';

import { SvgIcon, SvgIconProps } from '@thirdspacelearning/library';

interface Props extends SvgIconProps {}

const DialogBadgeAvailable: FC<Props> = ({ ...props }) => (
    <SvgIcon
        width="250"
        height="234"
        viewBox="0 0 250 234"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="dialog-badge-available"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M51.2068 130.979C52.5541 130.291 54.2609 130.532 55.1562 131.752L60.0803 138.458C60.9764 139.678 60.7191 141.406 59.4222 142.188C56.8283 143.751 54.0089 144.916 51.0576 145.64C47.2171 146.583 43.2286 146.76 39.3198 146.161C35.411 145.562 31.6584 144.199 28.2763 142.149C24.8943 140.1 21.949 137.405 19.6086 134.217C17.2682 131.03 15.5785 127.412 14.6361 123.572C13.6936 119.731 13.5168 115.743 14.1158 111.834C14.7148 107.925 16.0778 104.173 18.1271 100.791C19.7018 98.1917 21.6581 95.8507 23.9261 93.8438C25.06 92.8404 26.7856 93.1123 27.6817 94.3328L31.6634 99.7557C32.5588 100.975 32.2777 102.676 31.218 103.755C30.2946 104.696 29.4809 105.742 28.7947 106.875C27.6304 108.796 26.856 110.928 26.5156 113.149C26.1753 115.37 26.2757 117.636 26.8112 119.818C27.3467 122 28.3067 124.056 29.6364 125.867C30.9662 127.678 32.6396 129.209 34.5612 130.373C36.4828 131.538 38.6149 132.312 40.8358 132.652C43.0566 132.993 45.3228 132.892 47.5048 132.357C48.7909 132.041 50.0329 131.578 51.2068 130.979Z"
            fill="#B2EBF2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M181.485 13.6229C180.266 12.7265 179.717 11.0925 180.406 9.74559L184.195 2.33923C184.885 0.991265 186.545 0.447223 187.825 1.25659C190.384 2.87536 192.689 4.87385 194.659 7.18789C197.222 10.1992 199.167 13.6858 200.383 17.4487C201.599 21.2117 202.061 25.1772 201.744 29.1189C201.427 33.0607 200.337 36.9014 198.536 40.4218C196.735 43.9423 194.258 47.0735 191.247 49.6367C188.236 52.1998 184.749 54.1448 180.986 55.3605C177.223 56.5762 173.257 57.0388 169.316 56.722C166.287 56.4785 163.317 55.7784 160.507 54.6499C159.102 54.0856 158.572 52.4211 159.262 51.0732L162.326 45.084C163.015 43.7371 164.661 43.2265 166.101 43.6905C167.357 44.0949 168.657 44.3538 169.978 44.4599C172.217 44.64 174.47 44.3771 176.608 43.6864C178.746 42.9957 180.727 41.8906 182.438 40.4343C184.149 38.9779 185.556 37.1989 186.58 35.1987C187.603 33.1985 188.222 31.0163 188.403 28.7767C188.583 26.5371 188.32 24.284 187.629 22.146C186.938 20.008 185.833 18.027 184.377 16.3161C183.518 15.3073 182.547 14.4041 181.485 13.6229Z"
            fill="#FFCCBC"
        />
        <rect
            x="218.138"
            y="114.032"
            width="56.154"
            height="14.1565"
            rx="4.85903"
            transform="rotate(-115.532 218.138 114.032)"
            fill="#B2EBF2"
        />
        <rect
            x="184.245"
            y="91.4346"
            width="56.1539"
            height="14.1565"
            rx="4.85903"
            transform="rotate(-25.5324 184.245 91.4346)"
            fill="#B2EBF2"
        />
        <rect
            x="145.002"
            y="103.707"
            width="56.154"
            height="14.1565"
            rx="4.85903"
            transform="rotate(-115.532 145.002 103.707)"
            fill="#E1BEE7"
        />
        <rect
            x="111.109"
            y="81.1099"
            width="56.1539"
            height="14.1565"
            rx="4.85903"
            transform="rotate(-25.5324 111.109 81.1099)"
            fill="#E1BEE7"
        />
        <rect
            x="107.899"
            y="134.021"
            width="56.1539"
            height="14.1564"
            rx="4.85903"
            transform="rotate(-142.439 107.899 134.021)"
            fill="#FFE0B2"
        />
        <circle
            cx="6.62282"
            cy="6.62282"
            r="6.62282"
            transform="matrix(0.240397 0.970674 0.970674 -0.240397 59.5649 202.98)"
            fill="#E1BEE7"
        />
        <circle
            cx="6.62282"
            cy="6.62282"
            r="6.62282"
            transform="matrix(0.240397 0.970674 0.970674 -0.240397 50.0669 164.635)"
            fill="#E1BEE7"
        />
        <rect
            x="92.0464"
            y="188.703"
            width="56.154"
            height="14.1565"
            rx="4.85903"
            transform="rotate(166.09 92.0464 188.703)"
            fill="#E1BEE7"
        />
        <circle
            cx="6.62282"
            cy="6.62282"
            r="6.62282"
            transform="matrix(0.787632 0.616146 0.616146 -0.787632 44.1709 61.991)"
            fill="#FFE0B2"
        />
        <circle
            cx="6.62282"
            cy="6.62282"
            r="6.62282"
            transform="matrix(0.787632 0.616146 0.616146 -0.787632 13.0581 37.6501)"
            fill="#FFE0B2"
        />
        <rect
            x="60.9468"
            y="30.7253"
            width="56.1539"
            height="14.1565"
            rx="4.85903"
            transform="rotate(128.035 60.9468 30.7253)"
            fill="#FFE0B2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M152.373 154.727C152.547 156.23 151.724 157.745 150.268 158.158L142.263 160.426C140.806 160.839 139.277 159.993 138.999 158.505C138.441 155.528 138.335 152.479 138.689 149.461C139.149 145.534 140.378 141.735 142.306 138.283C144.234 134.83 146.823 131.791 149.926 129.339C153.029 126.887 156.584 125.07 160.388 123.992C164.193 122.914 168.173 122.596 172.1 123.056C176.028 123.516 179.826 124.746 183.279 126.674C186.732 128.602 189.771 131.191 192.223 134.293C194.107 136.678 195.616 139.329 196.703 142.156C197.246 143.569 196.388 145.09 194.932 145.503L188.46 147.337C187.004 147.749 185.509 146.891 184.868 145.521C184.31 144.326 183.614 143.198 182.793 142.159C181.4 140.396 179.673 138.925 177.712 137.829C175.75 136.734 173.592 136.035 171.36 135.774C169.129 135.513 166.867 135.693 164.706 136.306C162.544 136.918 160.524 137.95 158.761 139.344C156.999 140.737 155.527 142.463 154.432 144.425C153.336 146.387 152.638 148.545 152.377 150.776C152.223 152.092 152.222 153.418 152.373 154.727Z"
            fill="#FFCCBC"
        />
        <rect
            x="240.292"
            y="166.211"
            width="56.1539"
            height="14.1565"
            rx="4.85903"
            transform="rotate(156.601 240.292 166.211)"
            fill="#E1BEE7"
        />
        <rect
            x="135.591"
            y="221.121"
            width="56.1539"
            height="14.1565"
            rx="4.85903"
            transform="rotate(-69.3794 135.591 221.121)"
            fill="#FFE0B2"
        />
        <rect
            x="128.411"
            y="181.024"
            width="56.1539"
            height="14.1565"
            rx="4.85903"
            transform="rotate(20.6206 128.411 181.024)"
            fill="#FFE0B2"
        />
        <rect
            width="55.9028"
            height="14.0931"
            rx="4.83729"
            transform="matrix(0.333413 -0.942781 -0.942781 -0.333413 88.3389 59.7485)"
            fill="#B2EBF2"
        />
        <rect
            width="55.9027"
            height="14.0931"
            rx="4.83729"
            transform="matrix(-0.333413 0.942781 0.942781 0.333413 116.631 10.1899)"
            fill="#B2EBF2"
        />
        <path
            d="M129.742 90.2714L125.614 89.9088C124.582 89.8251 100.248 87.6079 90.6681 78.0417C78.2154 65.589 87.6281 56.1901 91.6443 52.174C95.6604 48.1579 105.059 38.7591 117.512 51.1979C127.078 60.764 129.295 85.1118 129.379 86.1437L129.742 90.2714ZM105.115 51.9509C102.382 51.9509 99.802 53.8613 96.5807 57.0965C90.71 62.9673 89.176 66.6767 95.6046 73.1052C100.918 78.4182 113.956 81.2909 121.932 82.4483C120.775 74.4858 117.902 61.4473 112.589 56.1204C109.689 53.2199 107.346 51.9369 105.115 51.9369V51.9509Z"
            fill="#C00030"
        />
        <path
            d="M124.54 90.2709L124.903 86.1432C124.986 85.1113 127.204 60.7775 136.77 51.1974C149.222 38.7447 158.621 48.1574 162.637 52.1736C166.654 56.1897 176.052 65.5885 163.614 78.0413C154.047 87.6074 129.7 89.8247 128.668 89.9083L124.54 90.2709ZM141.706 56.1339C136.393 61.4469 133.521 74.4993 132.363 82.4618C140.326 81.3044 153.364 78.4317 158.691 73.1187C165.12 66.6762 163.586 62.9808 157.715 57.11C151.844 51.2393 148.135 49.7053 141.706 56.1339Z"
            fill="#C00030"
        />
        <path
            d="M127.203 90.7732C132.456 90.7732 136.714 86.5153 136.714 81.2628C136.714 76.0104 132.456 71.7524 127.203 71.7524C121.951 71.7524 117.693 76.0104 117.693 81.2628C117.693 86.5153 121.951 90.7732 127.203 90.7732Z"
            fill="#C00030"
        />
        <path
            d="M193.766 97.5156H59.4014V179.188H193.766V97.5156Z"
            fill="#DF8603"
        />
        <path
            d="M198.238 81.2632H54.1313V102.766H198.238V81.2632Z"
            fill="#FFA726"
        />
        <rect
            x="117.177"
            y="81.9443"
            width="19.014"
            height="97.0715"
            fill="#C00030"
        />
    </SvgIcon>
);

export default DialogBadgeAvailable;
